
import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { MOQDisplay } from "../MOQDisplay";

interface InventoryItem {
  id: number;
  name: string;
  stock: number;
  minimum: number;
  status: string;
  moq?: number | null;
}

interface InventoryTableProps {
  items: InventoryItem[];
}

const InventoryTable = ({ items }: InventoryTableProps) => {
  // Get status display
  const getStatusDisplay = (status: string, stock: number, minimum: number) => {
    switch (status) {
      case "op_voorraad":
        return <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">Op voorraad</span>;
      case "bijna_op":
        return <span className="px-2 py-1 bg-yellow-100 text-yellow-800 rounded-full text-xs">Bijna op ({stock - minimum} over)</span>;
      case "tekort":
        return <span className="px-2 py-1 bg-red-100 text-red-800 rounded-full text-xs">Tekort ({minimum - stock} tekort)</span>;
      default:
        return <span className="px-2 py-1 bg-gray-100 text-gray-800 rounded-full text-xs">Onbekend</span>;
    }
  };

  return (
    <div className="border rounded-md">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Product</TableHead>
            <TableHead>Voorraad</TableHead>
            <TableHead>Minimaal</TableHead>
            <TableHead>MOQ</TableHead>
            <TableHead>Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {items.length > 0 ? (
            items.map((item) => (
              <TableRow key={item.id} className="cursor-pointer">
                <TableCell className="font-medium">{item.name}</TableCell>
                <TableCell>{item.stock}</TableCell>
                <TableCell>{item.minimum}</TableCell>
                <TableCell>
                  <MOQDisplay moq={item.moq} />
                </TableCell>
                <TableCell>
                  {getStatusDisplay(item.status, item.stock, item.minimum)}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={5} className="text-center text-muted-foreground">
                Geen producten gevonden
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default InventoryTable;

